/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantAccessDto
 */
export interface TenantAccessDto {
    /**
     * 
     * @type {boolean}
     * @memberof TenantAccessDto
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantAccessDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAccessDto
     */
    tenantName?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAccessDto
     */
    tenantSlug?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantAccessDto
     */
    permissions?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof TenantAccessDto
     */
    lastAccessed?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof TenantAccessDto
     */
    isActive?: boolean;
}

/**
 * Check if a given object implements the TenantAccessDto interface.
 */
export function instanceOfTenantAccessDto(value: object): value is TenantAccessDto {
    return true;
}

export function TenantAccessDtoFromJSON(json: any): TenantAccessDto {
    return TenantAccessDtoFromJSONTyped(json, false);
}

export function TenantAccessDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantAccessDto {
    if (json == null) {
        return json;
    }
    return {
        
        'active': json['active'] == null ? undefined : json['active'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'tenantName': json['tenant_name'] == null ? undefined : json['tenant_name'],
        'tenantSlug': json['tenant_slug'] == null ? undefined : json['tenant_slug'],
        'permissions': json['permissions'] == null ? undefined : json['permissions'],
        'lastAccessed': json['last_accessed'] == null ? undefined : (new Date(json['last_accessed'])),
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
    };
}

export function TenantAccessDtoToJSON(json: any): TenantAccessDto {
    return TenantAccessDtoToJSONTyped(json, false);
}

export function TenantAccessDtoToJSONTyped(value?: TenantAccessDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'active': value['active'],
        'tenant_id': value['tenantId'],
        'tenant_name': value['tenantName'],
        'tenant_slug': value['tenantSlug'],
        'permissions': value['permissions'],
        'last_accessed': value['lastAccessed'] == null ? undefined : ((value['lastAccessed']).toISOString()),
        'is_active': value['isActive'],
    };
}

